export default __webpack_public_path__ + "static/media/SBX.74fe7bbd.mp4";